export function setCookie(name, value, minutes) {
  var expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + minutes * 60 * 1000); // Convert minutes to milliseconds
  var expires = "expires=" + expirationDate.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

export function getCookie(name) {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

export function getDomainName(url) {
  try {
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    const hostname = new URL(url).hostname;
    const parts = hostname.split(".");

    const commonSecondLevelTlds = ["com", "co", "org", "net", "gov", "edu"];

    const last = parts[parts.length - 1];
    const secondLast = parts[parts.length - 2];

    if (
      parts.length >= 3 &&
      last.length === 2 &&
      commonSecondLevelTlds.includes(secondLast)
    ) {
      // example.com.bd -> example
      // example.co.uk -> example
      return parts[parts.length - 3];
    }

    return parts[parts.length - 2];
  } catch {
    return null;
  }
}

export function getUserType(value) {
  // Cirkle
  if (/^\+88016\d{8}$/.test(value)) {
    return "cirkle";
  }

  // Robi
  if (/^\+88018\d{8}$/.test(value)) {
    return "robi";
  }

  // Grameenphone
  if (/^(?:\+88017|\+88013|017|013)\d{8}$/.test(value)) {
    return "gp";
  }

  // Banglalink
  if (/^\+880(?:14|19)\d{8}$/.test(value)) {
    return "banglalink";
  }

  // Email
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return "email";
  }

  return "unsupported";
}
